/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { Switch, Route, Redirect } from "react-router-dom";
import Home from "./pages/Home";
import Tables from "./pages/Tables";
import Billing from "./pages/Billing";
import Rtl from "./pages/Rtl";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Stocks from "./pages/Stocks";
import Dividend from "./pages/Dividend";
import Correlation from "./pages/Correlation";
import DataEntry from "./pages/DataEntry";
import Indicators from "./pages/Indicators";
import Trading from "./pages/Trading";
import AccountBalance from "./pages/AccountBalance";
import Transactions from "./pages/Transactions";
import Profits from "./pages/Profits";
import QuickTrade from "./pages/QuickTrade";
import MobilePortfolio from "./pages/MobilePortfolio";
import Main from "./components/layout/Main";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import "./assets/styles/mobile-responsive.css";
import "./assets/styles/mobile-portfolio.css";

// Protected Route Component
const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/sign-in', state: { from: props.location } }} />
        )
      }
    />
  );
};

function AppContent() {
  return (
    <div className="App">
      <Switch>
        <ProtectedRoute exact path="/quick-trade/:tradeId" component={QuickTrade} />
        <ProtectedRoute exact path="/quick-trade" component={QuickTrade} />
        <ProtectedRoute exact path="/mobile" component={MobilePortfolio} />
        <Route exact path="/sign-up" component={SignUp} />
        <Route exact path="/sign-in" component={SignIn} />

        <ProtectedRoute exact path="/dashboard" component={(props) => <Main {...props}><Home /></Main>} />
        <ProtectedRoute exact path="/stocks" component={(props) => <Main {...props}><Stocks /></Main>} />
        <ProtectedRoute exact path="/dividend" component={(props) => <Main {...props}><Dividend /></Main>} />
        <ProtectedRoute exact path="/data-entry" component={(props) => <Main {...props}><DataEntry /></Main>} />
        <ProtectedRoute exact path="/indicators" component={(props) => <Main {...props}><Indicators /></Main>} />
        <ProtectedRoute exact path="/correlation" component={(props) => <Main {...props}><Correlation /></Main>} />
        <ProtectedRoute exact path="/trading" component={(props) => <Main {...props}><Trading /></Main>} />
        <ProtectedRoute exact path="/account-balance" component={(props) => <Main {...props}><AccountBalance /></Main>} />
        <ProtectedRoute exact path="/transactions" component={(props) => <Main {...props}><Transactions /></Main>} />
        <ProtectedRoute exact path="/profits" component={(props) => <Main {...props}><Profits /></Main>} />
        <ProtectedRoute exact path="/tables" component={(props) => <Main {...props}><Tables /></Main>} />
        <ProtectedRoute exact path="/billing" component={(props) => <Main {...props}><Billing /></Main>} />
        <ProtectedRoute exact path="/rtl" component={(props) => <Main {...props}><Rtl /></Main>} />
        <ProtectedRoute exact path="/profile" component={(props) => <Main {...props}><Profile /></Main>} />

        <Redirect exact from="/" to="/dashboard" />
        <Redirect to="/dashboard" />
      </Switch>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
